export default {
  // Restricted time window alert
  'restricted_time_window.alert_text':
    'A restricted time window is currently active for this team. All tests, experiments, and scenarios are disabled until {{endTime}}, UTC.',
  'restricted_time_window.schedule_alert':
    'This scheduled time occurs during a restricted time window, which runs from {{start}} to {{end}}. If you schedule an experiment at this time, it may not run.',
  'restricted_time_window.schedule_alert_with_day':
    'This scheduled time occurs during a restricted time window, which is active from {{start}} (UTC), to {{end}} (UTC). If you schedule an experiment at this time, it may not run.'
}
